module.exports = __webpack_public_path__ + "static/media/man1.da58dba3.png";